import api from './api';

export const postRegister = user =>
  api.post('/api/v1/auth/register', user)

export const postLogin = creds =>
  api.post('/api/v1/auth/login', creds)

export const postLogout = () =>
  api.post('/api/v1/auth/logout')